export default {
  guardiao_protetor: [
    {
      name: 'Armadura Completa de Guerra',
      desc: '1d8 + 1'
    },

    {
      name: 'Armadura de Aço Negro',
      desc: '1d10 + 2',
      mov: -1,
      dmg: -1
    },

    {
      name: 'Meia Armadura de Aço',
      desc: '1d6'
    }
  ],

  ninja: [
    {
      name: 'Kimono de Seda Negra',
      desc: '1d6 + 1'
    },

    {
      name: 'Disfarce Samurai',
      desc: '1d8 + 2',
      dmg: -1
    },

    {
      name: 'Colete Ninja',
      desc: '1d4'
    }
  ],

  necromante: [
    {
      name: 'Sobretudo das Sombras',
      desc: '1d4 + 1'
    },

    {
      name: 'Sobretudo Maligno de Onix',
      desc: '1d6 + 2',
      ph: -1
    },

    {
      name: 'Manto Negro',
      desc: '1d4'
    }
  ],

  alquimista: [
    {
      name: 'Jaleco Molecular Indestrutível',
      desc: '1d6 + 1'
    },

    {
      name: 'Pele de Aço',
      desc: '1d12 + 2',
      pv: -5,
      mov: -1,
      dmg: -1
    },

    {
      name: 'Jaleco "à prova de fogo"',
      desc: '1d4'
    }
  ],

  monge: [
    {
      name: 'Kimono Dourado',
      desc: '1d6 + 1'
    },

    {
      name: 'Kimono das Artes Ocultas',
      desc: '1d8 + 2',
      pv: -7
    },

    {
      name: 'Kimono Laranja',
      desc: '1d4'
    }
  ],

  ladino: [
    {
      name: 'Gibão de Pele de Unicórnio',
      desc: '1d6 + 1'
    },

    {
      name: 'Colete da Guilda da Morte',
      desc: '1d8 + 2',
      pv: -7
    },

    {
      name: 'Colete de Couro',
      desc: '1d4'
    }
  ],

  bardo: [
    {
      name: 'Colete de Viagem dos Eruditas',
      desc: '1d6 + 1'
    },

    {
      name: 'Gibão de Couro de Minotauro Negro',
      desc: '1d8 + 2',
      dmg: -1
    },

    {
      name: 'Colete de Couro',
      desc: '1d4'
    }
  ],

  mestre_modelador: [
    {
      name: '"O Manto"',
      desc: '1d6 + 1'
    },

    {
      name: 'Manto da Desolação',
      desc: '1d10 + 1',
      ph: -1
    },

    {
      name: 'Manto de Seda',
      desc: '1d4'
    }
  ],

  barbaro: [
    {
      name: 'Cota de Titanium',
      desc: '1d8 + 1'
    },

    {
      name: 'Armadura de Combate da Dor',
      desc: '1d12 + 2',
      pv: -10,
      mov: -1
    },

    {
      name: 'Cota de Aço Negro',
      desc: '1d6'
    }
  ],

  mercenario: [
    {
      name: 'Gibão de Pele de Ornitorrinco Gigante das Montanhas',
      desc: '1d6 + 1'
    },

    {
      name: 'Armadura de Casco de Kraken',
      desc: '1d10 + 2',
      pv: -10
    },

    {
      name: 'Gibão de Pele de Cobra',
      desc: '1d4'
    }
  ],

  mago: [
    {
      name: 'Capa das Runas Escarlate',
      desc: '1d6'
    },

    {
      name: 'Manto do Contrato com o Submundo',
      desc: '1d8 + 1',
      pv: -3
    },

    {
      name: 'Manto de Seda',
      desc: '1d4'
    }
  ],

  cacador: [
    {
      name: 'Gibão de Couro de Crocodilo Cinzento Abissal',
      desc: '1d6 + 1'
    },

    {
      name: 'Gibão de Couro de Gorila Reforçado com Marfim',
      desc: '1d8 + 2',
      ph: -1
    },

    {
      name: 'Gibão de Pele de Lobo Gigante Alfa',
      desc: '1d4'
    }
  ],

  guerreiro: [
    {
      name: 'Armadura de Guerra',
      desc: '1d8 + 1'
    },

    {
      name: 'Armadura Completa de Combate',
      desc: '1d10 + 2',
      mov: -1
    },

    {
      name: 'Meia Armadura de Cobre',
      desc: '1d6'
    }
  ],

  arqueiro: [
    {
      name: 'Cota de Malha Élfica',
      desc: '1d6 + 1'
    },

    {
      name: 'Cota de Correntes do Além',
      desc: '1d8 + 1',
      ph: -1
    },

    {
      name: 'Gibão de Pele de Raposa',
      desc: '1d4'
    }
  ],

  clerigo: [
    {
      name: 'Armadura de Prata Reluzente',
      desc: '1d8 + 1'
    },

    {
      name: 'Armadura de Ouro Vermelho',
      desc: '1d10 + 2',
      mov: -1
    },

    {
      name: 'Manto de Oração',
      desc: '1d4'
    }
  ],

  juiz: [
    {
      name: 'Armadura Real de Prata',
      desc: '1d8 + 1'
    },

    {
      name: 'Armadura Negra da Justiça',
      desc: '1d10 + 2',
      ph: -2
    },

    {
      name: 'Armadura de Batalha Reforçada',
      desc: '1d6'
    }
  ],

  general: [
    {
      name: 'Armadura Imperial de Prata',
      desc: '1d8 + 1'
    },

    {
      name: 'Armadura de Guerra de Aço Brilhante',
      desc: '1d12 +2',
      mov: -1,
      dmg: -1
    },

    {
      name: 'Armadura de Aço de Combate',
      desc: '1d6'
    }
  ],

  assassino: [
    {
      name: 'Sobretudo de Pele de Leão Negro',
      desc: '1d6 + 1'
    },

    {
      name: 'Sobretudo Amaldiçoado',
      desc: '1d8 + 2',
      ph: -1
    },

    {
      name: 'Sobretudo de Seda Negra',
      desc: '1d4'
    }
  ],

  xama: [
    {
      name: 'Manto Fantasma',
      desc: '1d6 + 1'
    },

    {
      name: 'Manto da Irmandade das Sombras',
      desc: '1d8 + 2',
      ph: -1
    },

    {
      name: 'Manto Tribal',
      desc: '1d4'
    }
  ],

  mimico: []
}
